import {
  ChakraTable,
  ChakraTbody as Tbody,
  ChakraBox as Box,
  ChakraTd as Td,
  ChakraTh as Th,
  ChakraThead as Thead,
  ChakraTr as Tr,
} from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import type { TableProps } from "./Table.d";

const Table = ({ thead = [], tbody = [], sbEditable }: SbEditableComponentProps<TableProps>) => (
  <Box bg="greyscale.200" py={2} px={6} borderRadius="lg" fontSize="sm" overflowX="auto" {...sbEditable}>
    <ChakraTable>
      <Thead>
        <Tr>
          {thead?.map(({ id, value }) => (
            <Th
              pl={0}
              pr={6}
              py={4}
              _last={{ pr: 0 }}
              key={id}
              minW={20}
              color="primary.900"
              textTransform="none"
              fontSize="sm"
              fontWeight="medium"
              letterSpacing="normal"
            >
              {value}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {tbody?.map(({ id: trId, td }, idx, arr) => {
          if (arr.length - 1 !== idx) {
            return (
              <Tr key={trId}>
                {td.map(({ id: tdId, value }) => (
                  <Td pl={0} pr={6} py={4} _last={{ pr: 0 }} key={tdId}>
                    {value}
                  </Td>
                ))}
              </Tr>
            );
          }
          return (
            <Tr key={trId}>
              {td.map(({ id: tdId, value }) => (
                <Td border="none" pl={0} pr={6} py={4} _last={{ pr: 0 }} key={tdId}>
                  {value}
                </Td>
              ))}
            </Tr>
          );
        })}
      </Tbody>
    </ChakraTable>
  </Box>
);

export default Table;
